export default "__VITE_ASSET__BteAOV6b__"